module.exports = __webpack_public_path__ + "static/images/typebg.f13c294.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/race/typebg.jpg
// module id = AdJh
// module chunks = 1